const unitConverter = function () {


    function convertToHum(unit, value) {
        return value;
    }

    function convertToTemp(unit, value) {
        return unit === "F" ? ((value * 9 / 5) + 32).toFixed(2) : value;
    }

    function convertToCo2(unit, value) {
        return unit === "%" ? value / 10000 : value;
    }

    function convertFromHum(unit, value) {
        return value;
    }

    function convertFromTemp(unit, value) {
        return unit === 'F' ? (value - 32) * 5 / 9 : value;
    }

    function convertFromCo2(unit, value) {
        return unit === '%' ? value * 10000 : value;

    }


    const convertTo = function (type, value, unit) {
        if (value === undefined) {
            return value;
        }

        let result;
        if (type === "hum" || type === "moisture") {
            result = convertToHum(unit, Number.parseFloat(value));
        } else if (type === "temp") {
            result = convertToTemp(unit, Number.parseFloat(value));
        } else if (type === "co2") {
            result = convertToCo2(unit, Number.parseFloat(value))
        } else {
            throw "Invalid type, Expected to be hum, temp ,co2 or moisture"
        }

        return Number.parseFloat(result);

    };




    function convertFrom(type, value, unit) {
        if (value === undefined) {
            return undefined
        }
        let result;
        if (type === "hum" || type === "moisture") {
            result = convertFromHum(unit, Number.parseFloat(value));
        } else if (type === "temp") {
            result = convertFromTemp(unit, Number.parseFloat(value));
        } else if (type === "co2") {
            result = convertFromCo2(unit, Number.parseFloat(value))
        } else {
            throw "Invalid type, Expected to be hum, temp ,co2 or moisture"
        }

        return Number.parseFloat(result);

    }

    return {
        convertTo: convertTo,
        convertFrom: convertFrom

    }

}();

export default unitConverter;